import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { getIconSize } from '../utilities/index.js';
const AccountOutlined = forwardRef(({ size = 'medium', fill = 'currentColor', ...props }, ref) => {
    const { iconWidth, iconHeight } = getIconSize(size);
    const ariaLabel = props['aria-label'];
    const ariaLabelledby = props['aria-labelledby'];
    let ariaHidden = true;
    if (ariaLabel || ariaLabelledby) {
        ariaHidden = false;
    }
    return (_jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", ref: ref, fill: fill, width: iconWidth, height: iconHeight, "aria-hidden": ariaHidden, ...props, children: [_jsx("path", { fillRule: "evenodd", d: "M15 6.25a5 5 0 1 1-10 0 5 5 0 0 1 10 0m-2.5 0a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0" }), _jsx("path", { d: "M6.25 12.5a5 5 0 0 0-5 5 1.25 1.25 0 1 0 2.5 0 2.5 2.5 0 0 1 2.5-2.5h7.5a2.5 2.5 0 0 1 2.5 2.5 1.25 1.25 0 1 0 2.5 0 5 5 0 0 0-5-5z" })] }));
});
AccountOutlined.displayName = 'AccountOutlined';
AccountOutlined.__iconComponentType = 'standard';
export default AccountOutlined;
//# sourceMappingURL=AccountOutlined.js.map